import 'devextreme/dist/css/dx.common.css';
import './themes/generated/theme.base.css';
import './themes/generated/theme.additional.css';
import React, { useEffect } from 'react';
import { HashRouter as Router } from 'react-router-dom';
import './dx-styles.scss';
import LoadPanel from 'devextreme-react/load-panel';
import { NavigationProvider } from './contexts/navigation';
import { AuthProvider, useAuth } from './contexts/auth';
import { useScreenSizeClass } from './utils/media-query';
import Content from './Content';
import UnauthenticatedContent from './UnauthenticatedContent';
import config from 'devextreme/core/config';
import { licenseKey } from './devextreme-license';
import { locale, loadMessages } from 'devextreme/localization';
import itMessages from 'devextreme/localization/messages/it.json';
import enMessages from 'devextreme/localization/messages/en.json';
import { useTranslation } from 'react-i18next';
config({ licenseKey }); 


function App() {
  const { i18n } = useTranslation();
  const { user, loading } = useAuth();
  
  useEffect(() => {
    if (i18n.language === 'it') {
      loadMessages(itMessages);
      locale('it');
    } else {
      loadMessages(enMessages);
      locale('en');
    }
  }, [i18n.language]); // React to changes in i18n.language 
  
  if (loading) {
    return <LoadPanel visible={true} />;
  }

  if (user) {
    return <Content />;
  }

  return <UnauthenticatedContent />;
}

export default function Root() {
  const screenSizeClass = useScreenSizeClass();
 
  
  // locale(navigator.language);
  locale(localStorage.getItem('i18nextLng') || navigator.language);
  config ({
    defaultCurrency: 'EUR',
    defaultUseCurrencyAccountingStyle: false
  });

  return (
    <Router>
      <AuthProvider>
        <NavigationProvider>
          <div className={`app ${screenSizeClass}`}>
            <App />
          </div>
        </NavigationProvider>
      </AuthProvider>
    </Router>
  );
}
